import { ResourceType } from '../../utils/enums';

export class Resource {
  /**
   *
   */
  constructor(public resourceType: ResourceType, public key: string, public data: any) {}
}
